import { gql } from '@apollo/client';

/* Inactivate / reactivate a business via an email OTP step-up (POGO-13731). */
export const REQUEST_STATUS_CHANGE = gql`
    mutation RequestBusinessStatusChange($input: RequestBusinessStatusChangeInput!) {
        requestBusinessStatusChange(input: $input) {
            expiresAt
            expiresBy
        }
    }
`;

export const VERIFY_STATUS_CHANGE = gql`
    mutation VerifyBusinessStatusChange($input: VerifyBusinessStatusChangeInput!) {
        verifyBusinessStatusChange(input: $input) {
            status
        }
    }
`;

/* Alex-only force-delete of a business that never requested deletion, via an
   email OTP step-up (POGO-13731 Phase 3). The server re-checks the allowlist. */
export const REQUEST_FORCE_DELETE = gql`
    mutation RequestForceDelete($input: RequestForceDeleteInput!) {
        requestForceDelete(input: $input) {
            expiresAt
            expiresBy
        }
    }
`;

export const VERIFY_FORCE_DELETE = gql`
    mutation VerifyForceDelete($input: VerifyForceDeleteInput!) {
        verifyForceDelete(input: $input) {
            message
        }
    }
`;
